module.exports = __webpack_public_path__ + "static/media/clear-share.af7e04af.svg";